import React, { useState } from "react";
import "./HRCopilotEraSection.css";

export default function RecruitmentDashboard() {
  const [selectedSection, setSelectedSection] = useState("candidates");

  const menuItems = [
    {
      id: "candidates",
      title: "1.8M candidates at your fingertips",
      badge: "START FREE",
      image: "/images/imag7.png",
      content:
        "Access millions of qualified candidates from around the world. Our platform helps you find the perfect match for your organization.",
      buttons: ["Browse Candidates", "Start Free Trial"],
    },
    {
      id: "smartmatch",
      title: "SmartMatch instant shortlists",
      badge: null,
      image: "/images/L1.png",
      content:
        "SmartMatch uses AI to instantly connect standout candidates to every role.",
      buttons: ["Try SmartMatch", "Learn More"],
    },
    {
      id: "interviews",
      title: "Recruitment Agent: AI Interviews",
      badge: null,
      image: "/images/one1.png",
      content:
        "Automate interviews with AI agents. Improve efficiency while maintaining candidate experience.",
      buttons: ["Schedule Demo", "View Features"],
    },
    {
      id: "tracking",
      title: "Applicant Tracking System",
      badge: null,
      image: "/images/one2.png",
      content:
        "Track every stage of the hiring pipeline with seamless automation. ATS built for modern teams.",
      buttons: ["Get Started", "Watch Demo"],
    },
    {
      id: "employer",
      title: "Employer of Record",
      badge: null,
      image: "/images/one6.png",
      content:
        "Hire globally with zero legal overhead. We manage payroll, compliance, and HR in 150+ countries.",
      buttons: ["Explore EOR", "Contact Sales"],
    },
    {
      id: "salary",
      title: "Salary benchmarking",
      badge: null,
      image: "/images/onbo1.png",
      content:
        "Access real-time salary insights for smarter compensation decisions.",
      buttons: ["View Salary Data", "Request Report"],
    },
    {
      id: "onboard",
      title: "Onboard instantly",
      badge: null,
      image: "/images/ap1.png",
      content:
        "Automate onboarding workflows and paperwork. Get new hires ready in minutes—not days.",
      buttons: ["Start Onboarding", "See How It Works"],
    },
  ];

  const selectedItem = menuItems.find((i) => i.id === selectedSection);

  return (
    <section className="rd-section">
      <div className="rd-wrap">
        
        {/* PAGE TITLE */}
        <h1 className="rd-page-title">
          Explore Your <span>Hiring Solutions</span>
        </h1>

        <div className="rd-container">
          
          {/* LEFT PANEL */}
          <aside className="rd-left">
            {menuItems.map((item) => (
              <div key={item.id} className="rd-menu-block">
                <div
                  className={`rd-menu-item ${
                    selectedSection === item.id ? "active" : ""
                  }`}
                  onClick={() => setSelectedSection(item.id)}
                >
                  <div className="rd-menu-left">
                    <span className="rd-menu-title">{item.title}</span>
                    {item.badge && <span className="rd-badge">{item.badge}</span>}
                  </div>
                  <span className="rd-plus">
                    {selectedSection === item.id ? "−" : "+"}
                  </span>
                </div>

                {selectedSection === item.id && (
                  <div className="rd-dropdown">
                    <p>{item.content}</p>

                    <div className="rd-button-row">
                      {item.buttons.map((btn, idx) => (
                        <button
                          key={idx}
                          className={idx === 0 ? "rd-btn-primary" : "rd-btn-secondary"}
                        >
                          {btn}
                        </button>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </aside>

          {/* RIGHT PANEL */}
          <main className="rd-right">
            <div className="rd-image-box">
              <img
                src={selectedItem.image}
                alt={selectedItem.title}
                className="rd-image"
              />
              <div className="rd-overlay">
                <h2>{selectedItem.title}</h2>
              </div>
            </div>
          </main>

        </div>
      </div>
    </section>
  );
}
